import { render, staticRenderFns } from "./ClosedLoanReport.vue?vue&type=template&id=2ef4cc6b&scoped=true&"
import script from "./ClosedLoanReport.vue?vue&type=script&lang=js&"
export * from "./ClosedLoanReport.vue?vue&type=script&lang=js&"
import style0 from "./ClosedLoanReport.vue?vue&type=style&index=0&id=2ef4cc6b&lang=scss&scoped=true&"
import style1 from "./ClosedLoanReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4cc6b",
  null
  
)

export default component.exports